import { Rectangle } from './components/shapes/Rectangle';
import { Square } from './components/shapes/Square';
import { Circle } from './components/shapes/Circle';
import { Ellipse } from './components/shapes/Ellipse';
// import { Poly } from './components/shapes/Poly';
import { Spline } from './components/shapes/Spline';
// import { Curve } from './components/shapes/Curve';
import { PolySpline } from './components/shapes/PolySpline';
import { ComplexPoly } from './components/shapes/ComplexPoly';
import { CrossArea } from './components/shapes/CrossArea';

export class ShapeFactory {
    static fromJSON(data) {
        if (!data || !data.type) return null;

        const {
            type,
            color,
            fillColor,
            fillType,
            spacing,
            angle,
            segmentLength,
            lineWidth,
            ...geometry
        } = data;

        let obj = null;

        switch (type) {
            case 'Rectangle':
                // Rectangle constructor: (x, y, width, height, color, fillColor, fillType, spacing, angle, segmentLength)
                obj = new Rectangle(
                    geometry.x,
                    geometry.y,
                    geometry.width,
                    geometry.height,
                    color,
                    fillColor,
                    fillType,
                    spacing,
                    angle,
                    segmentLength
                );
                break;
            case 'Square':
                // Square constructor: (x, y, size, color, fillColor, fillType, spacing, angle, segmentLength)
                obj = new Square(
                    geometry.x,
                    geometry.y,
                    geometry.size,
                    color,
                    fillColor,
                    fillType,
                    spacing,
                    angle,
                    segmentLength
                );
                break;
            case 'Circle':
                // Circle constructor: (centerX, centerY, radius, color, fillColor, fillType, spacing, angle, segmentLength)
                obj = new Circle(
                    geometry.centerX,
                    geometry.centerY,
                    geometry.radius,
                    color,
                    fillColor,
                    fillType,
                    spacing,
                    angle,
                    segmentLength
                );
                break;
            case 'Ellipse':
                obj = new Ellipse(geometry.points, color, fillColor, fillType, spacing, angle, segmentLength);
                break;
            case 'Poly':
                // Convert simple point array to PolySpline structure
                // Poly points are just {x,y}, we need {x,y,type:'line'} for PolySpline behavior
                const polyPoints = geometry.points.map(p => ({ ...p, type: 'line' }));
                obj = new PolySpline(polyPoints, color, fillColor, fillType, spacing, angle, segmentLength);
                break;
            case 'Spline':
                obj = new Spline(geometry.points, color, fillColor, fillType, spacing, angle, segmentLength);
                break;
            case 'Curve':
                // Convert Curve points to PolySpline interpolative points
                const curvePoints = geometry.points.map(p => ({ ...p, type: 'interpolative' }));
                obj = new PolySpline(curvePoints, color, fillColor, fillType, spacing, angle, segmentLength, geometry.tension);
                break;
            case 'PolySpline':
                obj = new PolySpline(geometry.pointsOrContours, color, fillColor, fillType, spacing, angle, segmentLength);
                break;
            case 'ComplexPoly':
                obj = new ComplexPoly(geometry.contours, color, fillColor, fillType, spacing, angle, segmentLength);
                break;
            case 'CrossArea':
                obj = new CrossArea(
                    geometry.x,
                    geometry.y,
                    geometry.cols,
                    geometry.rows,
                    geometry.crossSize,
                    color,
                    fillColor,
                    geometry.cells,
                    geometry.colorPalette
                );
                if (geometry.viewMode) obj.viewMode = geometry.viewMode;
                break;
            default:
                console.warn(`Unknown shape type: ${type}`);
                return null;
        }

        if (obj && lineWidth !== undefined) {
            obj.lineWidth = lineWidth;
        }

        return obj;
    }
}
